module.exports = __webpack_public_path__ + "static/img/kuaitiebao.0fc6a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/DiscountAgentInvite/H5/kuaitiebao.png
// module id = yqED
// module chunks = 70